import React from "react";
import TextField from "../FormComponents/TextField";
import { Container, Grid, Form } from "semantic-ui-react";
import styles from "./ForgetPassword.module.scss";
import { Heading2, Body2 } from "../value-cssmodules/TextComponent";
import MainButton from "../Button/MainButton";
import { toast } from 'react-toastify';

const ForgetPassword = () => {
  return (
    <div className={styles.self}>
      <Container className={styles.container}>
        <Grid centered>
  <Grid.Column mobile={16} computer={12}>
    
    <div className={styles.header}>
      <Heading2 className={styles.centered}>
        Nie pamiętasz hasła?
      </Heading2>

    <Body2 className={`${styles.centered} ${styles.subtitle}`}>
        Nie martw się! Wpisz poniżej swój adres e-mail, podany przez
        Ciebie przy rejestracji, a my wyślemy Ci nowe hasło.
      </Body2>
    </div>

    {/* FORM SECTION */}
    <Form onSubmit={() => toast.info("No submit function yet")}>
      <Form.Field className={styles.formField}>
        <TextField
          name="email"
          placeholder="Email"
          type="email"
        />

        <div className={styles.buttonWrapper}>
          <MainButton className={styles.loginMainButton}>
            Wyślij
          </MainButton>
        </div>
      </Form.Field>
    </Form>

  </Grid.Column>
</Grid>

         <div className={styles.footerContainer}>
                  <span className={styles.footerText}>
                    Pomyślnie zresetowano hasło. Na Twoją skrzynkę wysłaliśmy
                    wiadomość z nowym kodem dostępu.
                  </span>
                </div>
      </Container>
    </div>
  );
};

export default ForgetPassword;
